import { render, staticRenderFns } from "./DownloadFileAnchor.vue?vue&type=template&id=7009a665&"
import script from "./DownloadFileAnchor.vue?vue&type=script&lang=js&"
export * from "./DownloadFileAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7009a665')) {
      api.createRecord('7009a665', component.options)
    } else {
      api.reload('7009a665', component.options)
    }
    module.hot.accept("./DownloadFileAnchor.vue?vue&type=template&id=7009a665&", function () {
      api.rerender('7009a665', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/HelpfulHTMLElements/DownloadFileAnchor.vue"
export default component.exports